import PromiseHelper from "base/PromiseHelper";
import GraphController from "GraphController";
import GraphDataProvider from "GraphDataProvider";
import moment from "moment";

export default class GraphAnimation {
    constructor($element) {
        this.$element = $element;

        this.$phone = $element.find(".device--phone");
        this.$tablet = $element.find(".device--tablet");


        this.dataProvider = new GraphDataProvider();
        this.phoneGraph = new GraphController(this.$phone, "phone", this.dataProvider);
        this.tabletGraph = new GraphController(this.$tablet, "tablet", this.dataProvider);


        this.startAnimation();
    }

    async sleep(duration) {
        await PromiseHelper.timed_promise(duration);

    }

    async startAnimation() {
        await this.sleep(3000);

        this.startGraphAnimation(this.phoneGraph);
        await this.sleep(700);
        this.startGraphAnimation(this.tabletGraph);
    }

    /**
     * @param {GraphController} graph
     * @return {Promise<void>}
     */
    async startGraphAnimation(graph) {
        let $chartWrap = graph.$element.find(".device-layout__chart");
        let $startBtn = graph.$element.find(".js-start-btn");
        let $navigateBtn = graph.$element.find(".js-change-date[data-direction='forwards']");

        await this.tapElement($startBtn);

        $startBtn.hide();
        $chartWrap.addClass("device-layout__chart--loading");

        await this.sleep(800);

        $chartWrap.removeClass("device-layout__chart--loading").addClass("device-layout__chart--shown");
        graph.setDate(new Date());

        await this.sleep(1000);

        for (let i = 0; i < 3; i++) {
            await this.tapElement($navigateBtn);
            graph.setDate(moment().add(i + 1, "year").toDate());

            await this.sleep(1000);
        }
    }


    /**
     * Create a tap animation on this element
     *
     * @param {jQuery} $element
     */
    async tapElement($element) {
        if ($element.length === 0) {
            return;
        }

        let $tap = eotwJSXFactory('div', {className: "tap-simulator"});
        $element.append($tap);

        await this.sleep(200);
        $tap.addClass("tap-simulator--tap");
        await this.sleep(210);
        $tap.addClass("tap-simulator--remove");

        this.sleep(100).then(() => {
            $tap.remove();
        });
    }
}
